export default __webpack_public_path__ + "static/media/Links-BlankIMGs-04.5d754c1f.svg";